import React, { useContext, useMemo } from "react";
import { Badge, Box, Divider, IconButton, styled, Toolbar, InputBase } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SettingContext, useSettingContext } from "context/SettingContext";
import { ReactComponent as EditIcon } from "assets/icons/CatalogueCard/edit.svg";
import { ReactComponent as Sort } from "assets/icons/sort.svg";

import Button from "components/ui/Button";
import SettingBreadCrumbComponent from "components/ui/SettingBreadCrumbComponent";
import EditUserChildHeader from "./EditUserChildHeader";
import SelectRoleBtn from "./SelectRoleBtn";
import { removeRoles } from "features/Setting/Role/Apis/get-role";
import Unrestrict from "layouts/SubComponets/Unrestrict";
import SyncButton from "layouts/SubComponets/SyncButton";
import Tooltip from "components/ui/Tooltip";
import { ReactComponent as Filter } from "assets/filter/filter.svg";
import SortModal from "components/ui/SortModal";
import { useGlobalContext } from "context/GlobalContext";
import { useFilter } from "context/FilterContext";
import FilterModal from "components/ui/FilterModal/FilterModal";
import { getIcon } from "utils/iconsConfig";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import AddDesignModal from "features/Setting/Product_USP_and_Gallery/Modal/AddDesignModal";
import ServiceRequestIconChild from "components/ui/ServiceRequestIconChild";
import ActionButtons from "components/ui/ServiceRequestFlowModals/ActionModal/StatusActionButton";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { reopenMeltingRequestStatus, updateMeltingRequestStatus } from "features/Setting/Melting_Requests/API/meltingrequestapi";
import { useQueryClient } from "@tanstack/react-query";
import EditSelectModal from "components/ui/ServiceRequestFlowModals/EditModal/EditSelectModal";
import apiClient from "lib/api-client";
import { toast } from "react-toastify";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { formatDate } from "utils/formatDate";
import { printSlip } from "utils/printSlipFormat";

const StyledButton = styled(Button)(({ theme, variant, disabled }) => ({
  width: variant === "save" ? "168px" : variant === "cancel" ? "110px" : variant === "save-rights" ? "150px" : variant === "melting-save" ? "150px" : "160px",
  fontFamily: variant === "save-rights" ? "poppins" : "karla",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "21.04px",
  height: "41px",
  borderRadius: "5px",
  color: disabled ? "#B0B0B0" : variant === "save" ? "#50C878" : variant === "cancel" ? "#E77B7B" : variant === "save-rights" ? "#50C878" : variant === "melting-save" ? "#50C878" : "#FFF",
  border: `1px solid ${disabled ? "#B0B0B0" : variant === "save" ? "#50C878" : variant === "cancel" ? "#E77B7B" : variant === "save-rights" ? "#50C878" : variant === "melting-save" ? "#50C878" : "#fff"}`,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: disabled
      ? "transparent"
      : variant === "save"
        ? "#50C878"
        : variant === "cancel"
          ? "#E77B7B"
          : variant === "save-rights"
            ? "#50C878"
            : variant === "melting-save"
              ? "#50C878"
              : "#fff",
    color: disabled ? "#B0B0B0" : variant === "save" ? "#fff" : variant === "cancel" ? "#fff" : variant === "save-rights" ? "#fff" : variant === "melting-save" ? "#000" : "#000",
  },
}));

const MeltingCancelButton = styled(Button)(({}) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: "#E77B7B",
  border: "1px solid #E77B7B",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#E77B7B",
    color: "black",
  },

  "&.Mui-disabled": {
    backgroundColor: "transparent",
    color: "#444444",
    border: "1px solid #444444",
    cursor: "not-allowed",
    pointerEvents: "none",
  },
}));

const StyledAddButton = styled(Button)(({ theme }) => ({
  width: "90px",
  fontFamily: "karla",
  fontWeight: 700,
  fontSize: "18px",
  lineHeight: "21.04px",
  height: "42px",
  borderRadius: "5px",
  color: "#000",
  border: "none",
  textTransform: "none",
  backgroundColor: "#50C878",
  "&:hover": {
    backgroundColor: "#50C878",
    color: "#000",
  },
}));

function SettingChildHeader({ pageName, icon, deIcon }) {
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const { restrictBtn, syncButton, addModalOpen, setAddModalOpen } = useContext(SettingContext);
  const { isFilter, filterCount , isSetFilter} = useFilter();
  const permissions = usePermissions();
  const isAdmin = permissions?.isAdmin || false;

  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const { sortOptions, totals, currentStatus, meltingStatus, setMeltingStatus, serviceRequestDetail, activateFinalise } = useGlobalContext();

  // console.log({serviceRequestDetail})

  // console.log("Meling status",meltingStatus);

  const [sortOpen, setSortOpen] = useState(false);
  // const [addModalOpen, setAddModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showCard, setShowCard] = useState(false);
  const { meltingProducts } = useGlobalContext();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    heading: "",
    btnInfo: [],
  });

  const [editModal, setEditModal] = useState({
    open: false,
    title: "",
    btnTitle: "",
    placeHolder: "",
    btnInfo: [],
    onSubmit: null,
    // value: "",
    // onClick:()=>alert("");
  });

  // Melting request specific states
  const [isMeltingEditMode, setIsMeltingEditMode] = useState(false);
  const [meltingEditData, setMeltingEditData] = useState([]);
  const [meltingModalType, setMeltingModalType] = useState(""); // 'save' or 'cancel'
  const [meltingModalOpen, setMeltingModalOpen] = useState(false);
  const [isFinalising, setIsFinalising] = useState(false);
  const { meltingRequestId } = useParams();
  const queryClient = useQueryClient();

  const userData = JSON.parse(localStorage.getItem("userData"));

  const openActionModal = ({ heading, btnInfo, description }) => {
    setModalConfig({
      heading,
      description,
      btnInfo: btnInfo.map((btn) => ({
        ...btn,
        click: () => {
          btn.click?.();
          setModalOpen(false);
        },
      })),
    });

    setModalOpen(true);
  };

  const handleExport = () => {
    if (!Array.isArray(meltingProducts) || meltingProducts.length === 0) {
      alert("No products found");
      return;
    }

    const formattedData = meltingProducts.map((item, index) => ({
      SrNo: index + 1,
      JewelCode: item?.jewelId?.jewelCode || item?.jewelCode || item?.designNumber || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Melting Jewels");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, "Melting_Jewel_Codes.xlsx");
  };

  const handleModalClose = () => {
    setEditModal({ ...editModal, open: false });
    setTimeout(() => {
      setEditModal({ ...editModal, title: "", btnTitle: "", open: false, placeHolder: "", btnInfo: [] });
    }, 500);
  };

  const handleClose = () => {
    setSortOpen(false);
  };

  const {
    createUser,
    createBtn,
    creatBtnName,
    setCreateRole,
    roleEditBtn,
    createRole,
    openEditPage,
    setOpenEditPage,
    setRoleEditBtn,
    isDltClick,
    isUpdate,
    setIsUpdate,
    setUndoRole,
    undoRole,
    isChange,
    setIsChange,
    isRightPage,
    enableSaveRightsBtn,
    setSaveRightModalOpen,
    isLimitPage,
    enableSaveLimitsBtn,
    isNameChanged,
    missingImagesCount,
    restricateCatagoryCount,
    rateMaster,
    waba,
    syncCount,
    setAddClient,
    setEditTrayData,
    myBinnysReport,
    isDisable,
    setIsDisable,
    userCreateBtn,
    usercreatBtnName,
    onSave,
  } = useSettingContext();

  const navigation = useNavigate();
  const location = useLocation();
  const isUspGalleryPage = location.pathname.includes("product-usp-and-gallery");
  const state = location.state || {};

  const hasUserAddAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "User Management"), "add");
  const hasAddAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), "add");

  const isServiceRequestPage = location.pathname === "/Setting/service-request";

  // Check if it's melting requests main page (not detail page)
  const isMeltingRequestsMainPage = location.pathname.includes("/melting-requests") && location.pathname.split("/").length === 3;

  // Check if it's melting request detail page
  const isMeltingRequestDetail = location.pathname.includes("/melting-requests/") && location.pathname.split("/").length > 3;

  // Check for service request details
  const isServiceRequestDetailsPage =
    state?.name && typeof state.name === "string"
      ? state.name.includes("Service Request")
      : Array.isArray(state.name)
        ? state.name.some((name) => typeof name === "string" && name.includes("Service Request"))
        : false;

  // console.log("isServiceRequestDetailsPage===>>>",isServiceRequestDetailsPage)

  // Final check
  const finalCheck = isServiceRequestDetailsPage && Array.isArray(state.name) && state.name.length > 1 && !isServiceRequestPage;

  const isExactMatch = location.pathname === `/${pageName}` || location.pathname === `/${pageName.replace(/s$/, "")}`;

  let nextName = ["Settings"];

  // Effect to check for melting edit data
  useEffect(() => {
    if (isMeltingRequestsMainPage) {
      // Get edit data from sessionStorage or Redux
      const editData = JSON.parse(sessionStorage.getItem("meltingEditData") || "[]");
      setMeltingEditData(editData);
      setIsMeltingEditMode(editData.length > 0);
    }
  }, [location.pathname, isMeltingRequestsMainPage]);

  // Melting request handlers
  const handleMeltingSaveChanges = () => {
    console.log("Saving melting request changes:", meltingEditData);
    // Add your API call here to save changes
    // After successful save:
    resetMeltingEditMode();
  };

  const handleMeltingCancel = () => {
    resetMeltingEditMode();
  };

  const resetMeltingEditMode = () => {
    sessionStorage.removeItem("meltingEditData");
    setMeltingEditData([]);
    setIsMeltingEditMode(false);
    // You can trigger a data refresh here if needed
    window.dispatchEvent(new CustomEvent("meltingEditCancelled"));
  };

  // Modal button info for melting requests - single modal approach
  const meltingModalBtnInfo = useMemo(() => {
    if (meltingModalType === "save") {
      return [
        {
          btnName: "Yes, Remove",
          bgColor: "#E77B7B",
          click: () => {
            handleMeltingSaveChanges();
            setMeltingModalOpen(false);
          },
        },
        {
          btnName: "No",
          bgColor: "#50C878",
          click: () => setMeltingModalOpen(false),
        },
      ];
    } else {
      return [
        {
          btnName: "Yes, Discard",
          bgColor: "#E77B7B",
          click: () => {
            handleMeltingCancel();
            setMeltingModalOpen(false);
          },
        },
        {
          btnName: "No",
          bgColor: "#50C878",
          click: () => setMeltingModalOpen(false),
        },
      ];
    }
  }, [meltingModalType, queryClient]);

  useEffect(() => {
    const pathnames = location.pathname.split("/").filter((x) => x);
    const newBreadcrumbs = [];
    let newPath = "";
    let pathLength = pathnames.length;

    pathnames.forEach((name, index) => {
      newPath = newPath + "/" + name;
      if (name === "missing-images") {
        let mImages = missingImagesCount ? ` - ${missingImagesCount}` : "";
        newBreadcrumbs.push({
          name: `Missing Images`,
          path: newPath,
        });
      } else if (name === "restricted-designs" && pathLength == 2) {
        let categoryCount =
          restricateCatagoryCount?.totalCategoryCount && restricateCatagoryCount?.totalDesginCount
            ? ` - ${restricateCatagoryCount?.totalCategoryCount} (${restricateCatagoryCount?.totalDesginCount})`
            : "";
        newBreadcrumbs.push({
          name: `Restricted Category `,
          path: newPath,
        });
      } else if (name === "synchronize" && pathLength == 2) {
        let SyncCount = syncCount?.totalCount && syncCount?.cardCount ? ` - ${syncCount?.cardCount} (${syncCount?.totalCount})` : "";
        newBreadcrumbs.push({
          name: `Synchronize`,
          path: newPath,
        });
      } else {
        const nameFromState = state?.name && Array.isArray(state.name) && state.name[index - 1] ? state.name[index - 1] : "";
        newBreadcrumbs.push({
          name: nextName[index] ? nextName[index] : nameFromState || "",
          path: newPath,
        });
      }
    });

    if (state && state.subName && state.subName.trim() !== "") {
      newBreadcrumbs.push({
        name: state.subName,
        path: "",
      });
    }

    // console.log("Final Breadcrumbs:", newBreadcrumbs);

    // setBreadcrumbs(newBreadcrumbs);
    setBreadcrumbs(newBreadcrumbs.filter((b) => b.name && b.name.trim() !== ""));
  }, [location, missingImagesCount, restricateCatagoryCount, syncCount]);

  const handleUserFromOpen = () => {
    let state = {
      ...location?.state,
      name: [...(location?.state?.name || []), "Create User"],
    };
    setIsDisable(true);
    navigation("/Setting/users/addUser", { state });
  };

  const openCreateModal = () => {
    if (creatBtnName === "Create User") {
      handleUserFromOpen();
    }

    if (creatBtnName === "Create Role") {
      setCreateRole(true);
    }

    if (creatBtnName === "Add Client +") {
      setAddClient(hasAddAccess);
    }

    if (creatBtnName === "Add User +") {
      setAddClient(hasUserAddAccess);
    }

    if (creatBtnName === "Add Tray +") {
      setAddClient(true);
      setEditTrayData(null);
    }

    if (creatBtnName === "Add Event +") {
      setAddClient(hasAddClientAccess);
      setEditTrayData(null);
    }

    if (creatBtnName === "Save User") {
      onSave();
    }
  };

  const handleOpenEditPage = () => {
    setOpenEditPage(true);
    setRoleEditBtn(false);
  };

  const UndoDeleteRole = () => {
    handleCancelButton();

    setUndoRole(true);
    setIsChange(false);
  };

  const handleCancelButton = () => {
    let checkLocalStorageRemove = JSON.parse(localStorage.getItem("deletedRoles")) || [];
    let checkLocalStorageUpdate = JSON.parse(localStorage.getItem("updatedRoles")) || [];

    if (checkLocalStorageRemove.length > 0 || checkLocalStorageUpdate.length > 0) {
      setIsChange(true);
    } else {
      setIsChange(false);
    }
  };

  const goBackToRolePage = async () => {
    setOpenEditPage(false);
    setRoleEditBtn(true);
  };

  const handleRoleSave = async () => {
    const handleRoles = async (roles, isDelete, storageKey) => {
      if (roles.length === 0) return;

      const roleIds = roles.map(({ _id, roleName, roleToBeUpdated, updatedRoleName }) => ({
        roleId: _id || roleToBeUpdated._id,
        name: roleName || updatedRoleName,
      }));

      const response = await removeRoles(roleIds, isDelete);
      if (response.status === 200) {
        setOpenEditPage(false);
        setRoleEditBtn(true);
        setIsChange(false);
        localStorage.removeItem(storageKey);
        // toast.success(response.message, {
        //   autoClose: 1000,
        //   hideProgressBar: false,
        // });
      } else {
        alert("Error saving roles");
      }
    };

    const updatedRoles = JSON.parse(localStorage.getItem("updatedRoles")) || [];
    const deletedRoles = JSON.parse(localStorage.getItem("deletedRoles")) || [];

    await handleRoles(updatedRoles, false, "updatedRoles");
    await handleRoles(deletedRoles, true, "deletedRoles");
  };

  const permission = usePermissions();

  const handleSaveRightsModal = () => {
    setSaveRightModalOpen(true);
  };

  const handleSaveLimitsModal = () => {
    setSaveRightModalOpen(true);
  };

  if (location.pathname.match(/^\/Setting\/product-usp-and-gallery\/add-uspDetails\/[^/]+$/)) {
    return null;
  }

  if (location.pathname.match(/^\/Setting\/product-usp-and-gallery\/edit-uspDetails\/[^/]+$/)) {
    return null;
  }

  const hasAddClientAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Event Type"), "add");
  const hasAddButton = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Product USP and Gallery"), "add");
  const hasApproveButton = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Melting Request"), "approval_management");
  const hasAccessToFinaliseButton = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Melting Request"), "finalisation");

  return (
    <div style={{ position: "sticky", zIndex: "1000", top: "70px", background: "black" }}>
      <Box
        sx={{
          border: "1px solid #000",
          display: "flex",
          justifyContent: "center",
          padding: "0px",
          paddingBottom: "10px",
          position: "sticky",
          zIndex: "999",
          top: "70px",
          backgroundColor: "black !important",
        }}
        maxWidth={"100%"}
      >
        <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "95.4%" }} />
      </Box>
      {state?.isEditUser ? (
        <>
          <EditUserChildHeader />
        </>
      ) : (
        <>
          <div style={{ display: "grid", gridAutoFlow: "column", paddingTop: "10px", width: "100%" }}>
            <div className="child-header-sub" style={{ marginLeft: "20px", marginRight: "20px" }}>
              {!openEditPage ? (
                <>
                  {isExactMatch ? icon : deIcon}
                  <SettingBreadCrumbComponent breadcrumbs={breadcrumbs} />
                  <SortModal open={sortOpen} handleClose={handleClose} title="Sort By" list={sortOptions} />
                </>
              ) : (
                <h7 style={{ color: "#fff", fontFamily: "poppins", fontSize: "24px", fontWeight: "400" }}>Edit Page</h7>
              )}
            </div>
            <div className="child-header-sub" style={{ justifyContent: "flex-end", marginRight: "20px" }}>
              {!openEditPage ? (
                <>
                  {/* Melting Requests Save Changes/Cancel Buttons */}
                  {isMeltingRequestsMainPage && isMeltingEditMode && (
                    <div style={{ display: "flex", alignItems: "center", gap: "20px", marginRight: "20px" }}>
                      <StyledButton
                        variant="melting-save"
                        disabled={meltingEditData.length === 0}
                        onClick={() => {
                          setMeltingModalType("save");
                          setMeltingModalOpen(true);
                        }}
                      >
                        Save Changes
                      </StyledButton>
                      <MeltingCancelButton
                        onClick={() => {
                          setMeltingModalType("cancel");
                          setMeltingModalOpen(true);
                        }}
                      >
                        Cancel
                      </MeltingCancelButton>
                    </div>
                  )}

                  {/* Existing role edit button */}
                  {roleEditBtn && (
                    <IconButton disableRipple onClick={handleOpenEditPage}>
                      <EditIcon />
                    </IconButton>
                  )}

                  {location?.pathname === "/Setting/my-binnys-access" && totals && (
                    <div
                      className="flex gap-6"
                      // style={{ border: "1px solid red", display: "flex" }}
                      style={{ display: "flex", gap: "24px" }}
                    >
                      {/* Client Card */}
                      <div style={{ display: "flex", justifyContent: "center", gap: "6px", backgroundColor: "#0D0D0D", borderRadius: "5px", padding: "0px 32px", height: "41px" }}>
                        <span style={{ display: "flex", margin: "auto 0px" }}>{getIcon("multipleUserIcon")}</span>
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <p style={{ display: "flex", margin: "0px 0px", fontFamily: "Karla", fontSize: "12px", whiteSpace: "nowrap", fontWeight: "500", lineHeight: "20px" }}>Client :</p>
                          <p style={{ display: "flex", margin: "0px 0px", fontFamily: "Poppins", fontSize: "14px" }}>{totals.totalClients}</p>
                        </div>
                      </div>

                      {/* User Card */}

                      <div style={{ display: "flex", justifyContent: "center", gap: "6px", backgroundColor: "#0D0D0D", borderRadius: "5px", padding: "0px 32px", height: "41px" }}>
                        <span style={{ display: "flex", margin: "auto 0px" }}>{getIcon("singleUserIcon")}</span>
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <p style={{ display: "flex", margin: "0px 0px", fontFamily: "Karla", fontSize: "12px", whiteSpace: "nowrap", fontWeight: "500", lineHeight: "20px" }}>User :</p>
                          <p style={{ display: "flex", margin: "0px 0px", fontFamily: "Poppins", fontSize: "14px" }}>{totals.totalUsers}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {createBtn && !(creatBtnName === "Add Event +" && !hasAddClientAccess) && <StyledButton onClick={openCreateModal}>{creatBtnName}</StyledButton>}
                  {/* {createBtn && (
                    <StyledButton variant={creatBtnName === "Save User" ? "save" : null} disabled={isDisable} onClick={openCreateModal}>
                      {creatBtnName}
                    </StyledButton>
                  )} */}

                  {/* ----------------------- Rights Page ----------------------------- */}
                  {isRightPage && <SelectRoleBtn name={"Select Role"} />}
                  {isRightPage && (
                    <StyledButton variant="save-rights" disabled={!enableSaveRightsBtn} onClick={handleSaveRightsModal}>
                      Save Rights
                    </StyledButton>
                  )}

                  {/* ----------------------- Limits Page ----------------------------- */}

                  {(rateMaster || isLimitPage || waba) && <SelectRoleBtn name={"Select User"} />}
                  {(rateMaster || isLimitPage || waba || myBinnysReport) && (
                    <StyledButton variant="save-rights" disabled={!enableSaveLimitsBtn} onClick={handleSaveLimitsModal}>
                      {rateMaster || waba || myBinnysReport ? "Save" : "Save Limits"}
                    </StyledButton>
                  )}

                  {/* ----------------------- Restricted, Synchronise, and Design Import Page ----------------------------- */}

                  {syncButton && <SyncButton location={location} />}

                  {/* Service Request Icon */}
                  {isServiceRequestPage && (
                    <div className="child-header-sort">
                      <ServiceRequestIconChild />
                    </div>
                  )}

                  {/* Melting Request Detail Page Buttons */}
                  {isMeltingRequestDetail && !["approve", "remove"].includes(location.state?.mode) && (
                    <div style={{ display: "flex", gap: "32px", marginRight: "20px" }}>
                      {!meltingStatus || meltingStatus === "Finalise" ? null : meltingStatus === "Approved" ? (
                        // Show these buttons after approval
                        <>
                          {hasApproveButton && (
                            <StyledButton
                              onClick={() =>
                                openActionModal({
                                  heading: "Are you sure you want to resend for appproval?",
                                  btnInfo: [
                                    {
                                      btnName: "No",
                                      bgColor: "#d16565",
                                      textColor: "#000",
                                      hoverBgColor: "#d16565",
                                      click: () => {
                                        console.log("Resend for approval cancelled");
                                      },
                                    },
                                    {
                                      btnName: "Yes, Resend",
                                      bgColor: "#50C878",
                                      textColor: "#000",
                                      hoverBgColor: "#50C878",
                                      click: async () => {
                                        const payload = {
                                          melting_req_id: meltingRequestId,
                                          updateStatusValue: "Pending",
                                        };
                                        try {
                                          const res = await updateMeltingRequestStatus(payload);
                                          console.log("API response", res);
                                          queryClient.invalidateQueries({
                                            queryKey: ["melting-request-detail"],
                                          });
                                        } catch (error) {
                                          console.error("failed to pending", error);
                                        }
                                        queryClient.invalidateQueries({ queryKey: ["melting-requests"] });
                                      },
                                    },
                                  ],
                                })
                              }
                              style={{
                                backgroundColor: "#E47474",
                                width: "200px",
                                height: "42px",
                                color: "#000",
                                fontWeight: 500,
                                fontSize: "18px",
                                letterSpacing: "-0.41px",
                                fontFamily: "poppins",
                                border: "1px solid #E47474",
                                borderRadius: "5px",
                                "&:hover": {
                                  backgroundColor: "#d16565",
                                  color: "#000",
                                },
                              }}
                            >
                              Resend for Approval
                            </StyledButton>
                          )}
                          {hasAccessToFinaliseButton && (
                            <StyledButton
                              disabled={!activateFinalise || isFinalising}
                              onClick={() =>
                                openActionModal({
                                  heading: "Are you sure you want to finalise melting?",
                                  description: "(Once the melting is finalized, it cannot be reversed. The melting entry will be recorded in GATI)",
                                  btnInfo: [
                                    {
                                      btnName: "No",
                                      bgColor: "#E77B7B",
                                      textColor: "#000",
                                      hoverBgColor: "#d16565",
                                      click: () => {
                                        console.log("Finalise cancelled");
                                      },
                                    },
                                    {
                                      btnName: "Yes, Finalise",
                                      bgColor: "#50C878",
                                      textColor: "#000",
                                      hoverBgColor: "#47b86a",
                                      click: async () => {
                                        try {
                                          setIsFinalising(true);

                                          const stockResponse = await apiClient.get("/api/v1/stocks/sync-stockcollection");

                                          if (stockResponse?.status === 200) {
                                            const response = await apiClient.post(`/api/v1/melting_request/finalise/${meltingRequestId}`);

                                            let state = {
                                              ...location?.state,
                                              status: "Finalise",
                                            };

                                            toast.success(response.message, {
                                              autoClose: 2000,
                                              hideProgressBar: false,
                                            });

                                            navigation(`/Setting/melting-requests/${meltingRequestId}`, { state });

                                            setMeltingStatus("Finalise");

                                            queryClient.invalidateQueries(["melting-request", meltingRequestId]);
                                          }
                                        } catch (error) {
                                          toast.error(`${error?.response?.data?.message}`, {
                                            autoClose: 2000,
                                            hideProgressBar: false,
                                          });
                                        } finally {
                                          setIsFinalising(false);
                                        }
                                      },
                                    },
                                  ],
                                })
                              }
                              style={{
                                backgroundColor: !activateFinalise ? "#555050" : "#54D67E",
                                width: "160px",
                                height: "42px",
                                color: "#000",
                                fontWeight: 500,
                                fontSize: "18px",
                                fontFamily: "poppins",
                                letterSpacing: "-0.41px",
                                border: !activateFinalise ? "1px solid #555050" : "1px solid #54D67E",
                                borderRadius: "5px",
                                padding: "10px",
                                cursor: !activateFinalise || isFinalising ? "not-allowed" : "pointer",
                                "&:hover": {
                                  backgroundColor: !activateFinalise ? "#555050" : "#4ac371",
                                  color: "#000",
                                },
                              }}
                            >
                              {isFinalising ? "Finalising..." : "Finalise Melting"}
                            </StyledButton>
                          )}
                        </>
                      ) : meltingStatus === "Rejected" && isAdmin ? (
                        <>
                          <StyledButton
                            onClick={() =>
                              openActionModal({
                                heading: `Are you sure you want to reopen this ${state?.name[state?.name?.length - 1]}?`,
                                btnInfo: [
                                  {
                                    btnName: "No",
                                    bgColor: "#E77B7B",
                                    textColor: "#000",
                                    hoverBgColor: "#d16565",
                                    click: () => {
                                      console.log("Approval cancelled");
                                    },
                                  },
                                  {
                                    btnName: "Yes",
                                    bgColor: "#50C878",
                                    textColor: "#000",
                                    hoverBgColor: "#47b86a",
                                    click: async () => {
                                      try {
                                        const res = await reopenMeltingRequestStatus(meltingRequestId);

                                        queryClient.invalidateQueries({
                                          queryKey: ["melting-request-detail"],
                                        });
                                      } catch (error) {
                                        console.error("failed to apporve", error);
                                        toast.error(error?.response?.data?.message, {
                                          autoClose: 3000,
                                          hideProgressBar: false,
                                        });
                                      }
                                    },
                                  },
                                ],
                              })
                            }
                            style={{
                              backgroundColor: "#54D67E",
                              width: "125px",
                              height: "42px",
                              color: "#000",
                              fontWeight: 500,
                              fontSize: "18px",
                              fontFamily: "poppins",
                              border: "1px solid #54D67E",
                              borderRadius: "5px",
                              "&:hover": {
                                backgroundColor: "#4ac371",
                                color: "#000",
                              },
                            }}
                          >
                            Reopen
                          </StyledButton>
                        </>
                      ) : (
                        meltingStatus === "Pending" && (
                          // Show the original buttons (Reject, Remove, Approve)
                          <>
                            {hasApproveButton && (
                              <StyledButton
                                onClick={() =>
                                  openActionModal({
                                    heading: "Are you sure you want to reject melting request?",
                                    btnInfo: [
                                      {
                                        btnName: "Yes, Reject",
                                        bgColor: "#E47474",
                                        textColor: "#000",
                                        hoverBgColor: "#d16565",
                                        click: async () => {
                                          const payload = {
                                            melting_req_id: meltingRequestId,
                                            updateStatusValue: "Rejected",
                                          };
                                          try {
                                            const res = await updateMeltingRequestStatus(payload);
                                            console.log("API response", res);
                                            queryClient.invalidateQueries({
                                              queryKey: ["melting-request-detail"],
                                            });
                                          } catch (error) {
                                            console.error("failed to reject", error);
                                          }
                                        },
                                      },
                                      {
                                        btnName: "Keep",
                                        bgColor: "#50C878",
                                        textColor: "#000",
                                        hoverBgColor: "#47b86a",
                                        click: () => {
                                          console.log("Action cancelled");
                                        },
                                      },
                                    ],
                                  })
                                }
                                style={{
                                  backgroundColor: "#E47474",
                                  width: "125px",
                                  height: "42px",
                                  color: "#000",
                                  fontWeight: 500,
                                  fontSize: "18px",
                                  fontFamily: "poppins",
                                  border: "1px solid #E47474",
                                  borderRadius: "5px",
                                  "&:hover": {
                                    backgroundColor: "#d16565",
                                    color: "#000",
                                  },
                                }}
                              >
                                Reject
                              </StyledButton>
                            )}
                            {hasApproveButton && (
                              <StyledButton
                                onClick={() => {
                                  // Enter remove/edit mode
                                  navigation(location.pathname, {
                                    state: {
                                      ...location.state,
                                      mode: "remove",
                                      isRestricted: true,
                                    },
                                  });
                                }}
                                style={{
                                  backgroundColor: "#FFF55D",
                                  width: "125px",
                                  height: "42px",
                                  color: "#000",
                                  fontWeight: 500,
                                  fontSize: "18px",
                                  fontFamily: "poppins",
                                  border: "1px solid #FFF55D",
                                  borderRadius: "5px",
                                  "&:hover": {
                                    backgroundColor: "#f0e84d",
                                    color: "#000",
                                  },
                                }}
                              >
                                Remove
                              </StyledButton>
                            )}
                            {hasApproveButton && (
                              <StyledButton
                                onClick={() =>
                                  openActionModal({
                                    heading: "Are you sure you want to Approve?",
                                    btnInfo: [
                                      {
                                        btnName: "No",
                                        bgColor: "#E77B7B",
                                        textColor: "#000",
                                        hoverBgColor: "#d16565",
                                        click: () => {
                                          console.log("Approval cancelled");
                                        },
                                      },
                                      {
                                        btnName: "Yes, Approve",
                                        bgColor: "#50C878",
                                        textColor: "#000",
                                        hoverBgColor: "#47b86a",
                                        click: async () => {
                                          const payload = {
                                            melting_req_id: meltingRequestId,
                                            updateStatusValue: "Approved",
                                          };
                                          try {
                                            const res = await updateMeltingRequestStatus(payload);
                                            console.log("API response", res);
                                            queryClient.invalidateQueries({
                                              queryKey: ["melting-request-detail"],
                                            });
                                          } catch (error) {
                                            console.error("failed to apporve", error);
                                          }
                                        },
                                      },
                                    ],
                                  })
                                }
                                style={{
                                  backgroundColor: "#54D67E",
                                  width: "125px",
                                  height: "42px",
                                  color: "#000",
                                  fontWeight: 500,
                                  fontSize: "18px",
                                  fontFamily: "poppins",
                                  border: "1px solid #54D67E",
                                  borderRadius: "5px",
                                  "&:hover": {
                                    backgroundColor: "#4ac371",
                                    color: "#000",
                                  },
                                }}
                              >
                                Approve
                              </StyledButton>
                            )}
                          </>
                        )
                      )}
                      <StyledButton sx={{ width: "120px" }} onClick={handleExport}>
                        Export
                      </StyledButton>
                    </div>
                  )}

                  {/* Service Request Action Buttons */}
                  {finalCheck && <ActionButtons status={currentStatus} onAction={openActionModal} setModal={setEditModal} />}

                  {/* Filter Button */}
                  {isFilter && (
                    <div className="child-header-sort">
                      <Tooltip title="Filter">
                        <IconButton onClick={() => setFilterModalOpen(true)} disableRipple disableFocusRipple>
                          <Badge
                            badgeContent={filterCount}
                            color="success"
                            sx={{
                              "& .MuiBadge-badge": {
                                fontSize: "14px",
                              },
                            }}
                          >
                            <Filter />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                    </div>
                  )}

                  {/* Archive Filter Button */}
                  {isSetFilter && (
                    <div className="child-header-sort">
                      <Tooltip title="Archive Filter">
                        <IconButton onClick={() => setFilterModalOpen(true)} disableRipple disableFocusRipple>
                          <Badge
                            badgeContent={filterCount}
                            color="success"
                            sx={{
                              "& .MuiBadge-badge": {
                                fontSize: "14px",
                              },
                            }}
                          >
                            <Filter />
                          </Badge>
                        </IconButton>
                      </Tooltip>
                    </div>
                  )}

                  <FilterModal open={filterModalOpen} setOpen={setFilterModalOpen} />

                  {/* Sort Button */}
                  {sortOptions.length > 0 && (
                    <Tooltip title="Sort By">
                      <IconButton onClick={() => setSortOpen(true)} disableRipple disableFocusRipple>
                        <Sort />
                      </IconButton>
                    </Tooltip>
                  )}

                  <EditSelectModal
                    open={editModal?.open}
                    onClose={() => handleModalClose()}
                    title={editModal?.title}
                    placeHolder={editModal?.placeHolder}
                    value={""}
                    options={["Seznik_Veer_47D2", "Seznik_Veer_47D2", "Seznik_Veer_47D2"]}
                    btnTitle={editModal?.btnTitle}
                    btnInfo={editModal?.btnInfo}
                    onSave={(val) => {
                      // alert("done");

                      // const slipData = {
                      //   companyName: "Binnys",
                      //   srNo: 1232,
                      //   clientName: "Sunit Salunkhe",
                      //   clientCode: "EMP0284",
                      //   designNo: "BA-2308",
                      //   dueDate: "25-03-2026",
                      //   grossWt: "10g",
                      //   diamondWt: "2ct",
                      //   concern: "Urgent",
                      //   username: "Shadow",
                      // };
                      const slipData = {
                        companyName: "Binnys",
                        srNo: serviceRequestDetail?.serviceRequestId,
                        clientName: serviceRequestDetail?.clientName,
                        clientCode: serviceRequestDetail?.clientCode,
                        designNo: serviceRequestDetail?.designNo,
                        dueDate: formatDate(serviceRequestDetail?.createdAt),
                        grossWt: `${val[0]?.value}${val[0]?.suffix}` || "0g",
                        diamondWt: val?.[1]?.value > 0 ? `${val[1].value}${val[1].suffix || "ct"}` : "NA",
                        concern: serviceRequestDetail?.concern,
                        username: userData?.username,
                      };
                      printSlip(slipData);
                      if (editModal?.onSubmit) {
                        const values = {};
                        (editModal.btnInfo || []).forEach((field) => {
                          values[field.btnName] = field.value;
                        });
                        editModal.onSubmit(values);
                      }
                    }}
                  />
                </>
              ) : (
                <>
                  {/* Role Edit Mode Buttons */}
                  <StyledButton variant="save" disabled={!(isDltClick || isNameChanged)} onClick={handleRoleSave}>
                    Save Changes
                  </StyledButton>

                  <StyledButton variant="cancel" onClick={isChange ? UndoDeleteRole : goBackToRolePage}>
                    Cancel
                  </StyledButton>
                </>
              )}
              {isUspGalleryPage && hasAddButton && (
                <StyledAddButton onClick={() => setAddModalOpen(true)} disableRipple disableFocusRipple>
                  Add +
                </StyledAddButton>
              )}
            </div>
          </div>
        </>
      )}

      {/* Modals */}
      <RemoveModal open={modalOpen} setOpen={setModalOpen} heading={modalConfig.heading} description={modalConfig.description} btnInfo={modalConfig.btnInfo} oneLiner={true} />

      {/* Melting Request Modal - Single modal with conditional content */}
      <RemoveModal
        open={meltingModalOpen}
        setOpen={setMeltingModalOpen}
        heading={meltingModalType === "save" ? `Are you sure want to Remove ${meltingEditData.length || 0} Design${meltingEditData.length !== 1 ? "s" : ""}?` : "Do you want to Discard all changes?"}
        btnInfo={meltingModalBtnInfo}
        oneLiner={true}
      />
    </div>
  );
}

export default SettingChildHeader;
